// The geom API's name property isn't fixed across approaches/exits, so try the known candidates
const getFeatureName = (props = {}) =>
  props?.name ?? props?.nameApproach ?? props?.nameExit ?? props?.label;

export default getFeatureName;
